import React, { lazy, Suspense } from 'react';
import { useIsMounted } from '@wix/da-hooks/dist/src/useIsMounted';

const Layout = lazy(
  () => import(/* webpackChunkName: "protoLayout" */ './MultiTopLayout')
);

export interface Props {}

const MultiTop: React.FC<Props> = () => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  return (
    <Suspense fallback={'Loading...'}>
      <Layout />
    </Suspense>
  );
};
MultiTop.displayName = 'MultiTop';

export default MultiTop;
